// extracted by css-extract-rspack-plugin
export default {"root":"yjW5y","menu":"y9AEG","label":"lBFfW","cursorPointer":"Jb60O"};